module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md8": ""
    }
  }, [_c('sk-panel', [_c('h3', [_vm._v("Your Payment Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "checkout",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "checkout-form"
    },
    on: {
      "submit": function($event) {
        _vm.continueToNextStep()
      }
    }
  }, [_c('p', {
    staticClass: "form-alert"
  }, [_vm._v("All fields are mandatory")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "cardHolder",
      "autocomplete": "cardHolder",
      "label": "Cardholder Name",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter the name on the card.'
      }
    },
    model: {
      value: (_vm.card.cardHolder),
      callback: function($$v) {
        _vm.$set(_vm.card, "cardHolder", $$v)
      },
      expression: "card.cardHolder"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "cardNumber",
      "type": "number",
      "label": "Credit Card Number",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your credit card number.'
      }
    },
    model: {
      value: (_vm.card.cardNumber),
      callback: function($$v) {
        _vm.$set(_vm.card, "cardNumber", $$v)
      },
      expression: "card.cardNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Expiry Date")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-select', {
    attrs: {
      "placeholder": "Month",
      "type": "number"
    },
    model: {
      value: (_vm.card.expiryMonth),
      callback: function($$v) {
        _vm.$set(_vm.card, "expiryMonth", $$v)
      },
      expression: "card.expiryMonth"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Expiry Month")]), _vm._v(" "), _vm._l((_vm.months), function(month) {
    return (month != undefined && month != null) ? _c('option', {
      domProps: {
        "value": month.value
      }
    }, [_vm._v(_vm._s(month.name))]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-select', {
    attrs: {
      "placeholder": "Year",
      "type": "number"
    },
    model: {
      value: (_vm.card.expiryYear),
      callback: function($$v) {
        _vm.$set(_vm.card, "expiryYear", $$v)
      },
      expression: "card.expiryYear"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Expiry Year")]), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return (year != undefined && year != null) ? _c('option', {
      domProps: {
        "value": year.year
      }
    }, [_vm._v(_vm._s(year.year))]) : _vm._e()
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "cvvNumber",
      "type": "number",
      "autocomplete": "cvvNumber",
      "label": "CVV Number",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter the CVV number at the back of the card.'
      }
    },
    model: {
      value: (_vm.card.cvvNumber),
      callback: function($$v) {
        _vm.$set(_vm.card, "cvvNumber", $$v)
      },
      expression: "card.cvvNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "subscribe-payment-debit-day",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "debit-order-label",
    attrs: {
      "for": "debitOrderDay"
    }
  }, [_vm._v("\n                                  Debit OrderDay "), _c('sk-tooltip', {
    key: "debit-order-tooltip",
    attrs: {
      "content": "This should probably be on payday. The subscription is for a minimum of three months and the second month will be deducted on this day.",
      "standalone": ""
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-select', {
    attrs: {
      "placeholder": "Month",
      "type": "number",
      "required": "",
      "error-message": {
        valueMissing: 'Please select a debit order day.'
      }
    },
    model: {
      value: (_vm.card.debitOrderDay),
      callback: function($$v) {
        _vm.$set(_vm.card, "debitOrderDay", $$v)
      },
      expression: "card.debitOrderDay"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Debit Order Day")]), _vm._v(" "), _vm._l((_vm.debitDays), function(day) {
    return (day != undefined && day != null) ? _c('option', {
      domProps: {
        "value": day.day
      }
    }, [_vm._v(_vm._s(day.name))]) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), _c('p', [_vm._v("By clicking pay, you agree to our "), _c('a', {
    attrs: {
      "href": "/content/legal/Fan%20Club%20T's%20and%20C's",
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")])]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "payment-info": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "text-right": ""
    }
  }, [_c('p', {
    staticClass: "text--small"
  }, [_vm._v("Ster-Kinekor is secure. For credit card payments we accept")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/visa.png",
      "alt": "Visa"
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/master-card.png",
      "alt": "Master Card"
    }
  })])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    class: _vm.$breakpoints.smDown ? 'text-right' : '',
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "payment-footer": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm10": "",
      "grow": "",
      "text-right": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "payment-footer-btns": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.subsClub.item.Description == 'Limited Subs') ? [(!_vm.loadingPayment) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "contextValue": "Subscription make payment",
      "dataValue": "Pay for Fan club"
    }
  }, [_vm._v("PAY " + _vm._s(_vm.subsClub.item.Price))]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.subsClub.item.Description == 'Unlimited Subs') ? [(!_vm.loadingPayment) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "contextValue": "Subscription make payment",
      "dataValue": "Pay for Morvies club"
    }
  }, [_vm._v("PAY " + _vm._s(_vm.subsClub.item.Price))]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.loadingPayment) ? _c('sk-button', {
    attrs: {
      "disabled": "",
      "primary": ""
    }
  }, [_vm._v("PAY " + _vm._s(_vm.subsClub.item.Price))]) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": "/subscribe/2",
      "contextValue": "Subscription make payment",
      "dataValue": "Back to confirm details"
    }
  }, [_vm._v("Back")])], 1)], 1)], 1), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "id": "frmLaunchACS",
      "name": "frmLaunchACS",
      "action": "",
      "method": "POST"
    }
  }, [_c('textarea', {
    attrs: {
      "id": "PaReq",
      "name": "PaReq"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "TermUrl",
      "name": "TermUrl",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "MD",
      "name": "MD",
      "value": ""
    }
  })])], 1)])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', [(_vm.subsClub.item.Description == 'Limited Subs') ? [_c('div', {
    staticClass: "limited-subs"
  }, [_c('h3', [_vm._v("Subscription Summary")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "img-responsive img-option",
    attrs: {
      "src": "/static/img/fan_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    staticClass: "subscription-summary-heading",
    attrs: {
      "xs7": ""
    }
  }, [_c('p', [_c('span', [_vm._v("LIMITED MOVIE TICKETS PER MONTH")]), _c('br'), _vm._v("\n                                    You get 4 2D or 3D movie tickets per month for you and your family.\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("4 MOVIE TICKETS TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                    You watch more for less\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                    20% off a regular combo\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("IDEAL FOR THE FAMILY")]), _vm._v(" "), _c('br'), _vm._v("\n                                    Use one or all four tickets at once\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Eastgate Shopping Centre (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Sandton City (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Cresta Shopping Centre (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Brooklyn Mall (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Brooklyn Mall Nouveau (GAU)")]), _vm._v(" "), _c('li', [_vm._v("I'langa Mall (MPL)")]), _vm._v(" "), _c('li', [_vm._v("Gateway Mall (KZN)")]), _vm._v(" "), _c('li', [_vm._v("Watercrest Mall (KZN)")]), _vm._v(" "), _c('li', [_vm._v("Blue Route (WC)")]), _vm._v(" "), _c('li', [_vm._v("Somerset Mall (WC)")]), _vm._v(" "), _c('li', [_vm._v("Garden Route Mall (WC)")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ticket-component"
  }, [_c('div', {
    staticClass: "ticket-component-wrapper ticket-component-total"
  }, [_c('div', {
    staticClass: "ticket-total"
  }, [_c('div', {
    staticClass: "layout row"
  }, [_c('div', {
    staticClass: "flex xs12 sm12"
  }, [_c('p', [_vm._v("Total " + _vm._s(_vm.subsClub.item.Price) + " "), _c('span', [_vm._v("per month")])])])])])])])], 1)] : _vm._e(), _vm._v(" "), (_vm.subsClub.item.Description == 'Unlimited Subs') ? [_c('div', {
    staticClass: "unlimited-subs"
  }, [_c('h3', [_vm._v("Subscription Summary")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "img-responsive img-option",
    attrs: {
      "src": "/static/img/morvies_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    staticClass: "subscription-summary-heading",
    attrs: {
      "xs7": ""
    }
  }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIES PER MONTH")]), _c('br'), _vm._v("\n                                    Watch as many 2D or 3D movies as you want all month long.\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                    Watch up to 5 movies a day, every day!\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                    20% off a regular combo\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("COME AS OFTEN AS YOU CAN")]), _vm._v(" "), _c('br'), _vm._v("\n                                    1 ticket per movie per card holder \n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Eastgate Shopping Centre (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Sandton City (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Cresta Shopping Centre (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Brooklyn Mall (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Brooklyn Mall Nouveau (GAU)")]), _vm._v(" "), _c('li', [_vm._v("I'langa Mall (MPL)")]), _vm._v(" "), _c('li', [_vm._v("Gateway Mall (KZN)")]), _vm._v(" "), _c('li', [_vm._v("Watercrest Mall (KZN)")]), _vm._v(" "), _c('li', [_vm._v("Blue Route (WC)")]), _vm._v(" "), _c('li', [_vm._v("Somerset Mall (WC)")]), _vm._v(" "), _c('li', [_vm._v("Garden Route Mall (WC)")])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "ticket-component-wrapper ticket-component-total"
  }, [_c('div', {
    staticClass: "ticket-total"
  }, [_c('div', {
    staticClass: "layout row"
  }, [_c('div', {
    staticClass: "flex xs12 sm12"
  }, [_c('p', [_vm._v("Total " + _vm._s(_vm.subsClub.item.Price) + " "), _c('span', [_vm._v("per month")])])])])])])])], 1)] : _vm._e()], 2)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-476e75cb","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subs-club/payment/payment.vue
// module id = 810
// module chunks = 0